import norwegian from "./no_NB/translations.json"
import english from "./en_US/translations.json"

function GetTexts(locale) {
    switch (locale) {
        case "no":
            return norwegian;
        case "en":
            return english;
        default:
            return english;
    }
}

export default GetTexts;